import styled from "styled-components";

export const Frame = styled.div`
  width: 1200px;
  margin: auto;

  @media (max-width: 768px) {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
  }
`;

export const Contents = styled.div``;
